import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { delay } from 'rxjs/operators';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-sistema',
  templateUrl: './sistema.component.html',
  styleUrls: ['./sistema.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class SistemaComponent implements OnInit {
  errMsg:string = "";
  errLogMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 3100;
  loading:boolean=false;
  hoy:string="";
  esFechaEspecial:boolean=false;
  fechaEspecial:any = moment().add(-1,"d");
  fecIni:any = moment();
  ultFolio:number=-1;
  sigFolio:number=-1;
  impresionTickets:string="";
  contraImpresionTickets:string="";
  abrirDescargarPDF:number=-1;
  editaFolio:boolean=false;
  editaFecha:boolean=false;
  enviandoCorreo:number=-1;
  admonCorreo:any=[];
  correoLog:string="";
  idAdmon:number=-1;
  editaCorreo:boolean=false;
  foliosAreasDefault:number=-1;
  reciboAreas:string="";
  contraReciboAreas:string="";
  resultado:any;
  ayer:any = new Date();
  admons:any=[];

  enviandoCorreo_log:number=-1;
  envioMail:any;

  cteSAE:number=-1;
  editaCteSAE:boolean=false;
  auxSerSAE:any;
  serSAE:string="";
  editaSerSAE:boolean=false;

  thisForm = new FormGroup({
    folio: new FormControl(this.sigFolio, [Validators.required]),
    fecEsp: new FormControl(this.fechaEspecial, []),
    cboAdmon: new FormControl(this.idAdmon, []),
    cteSAE: new FormControl(this.cteSAE, [Validators.required]),
    serSAE: new FormControl(this.serSAE, [Validators.required]),
  });

  constructor(private dataService: DataService) {
    this.ayer.setDate(this.ayer.getDate() - 1);
    //console.log(this.fechaEspecial)
   }

  ngOnInit() {
    this.loading=true;
    this.dataService.ultFolio().subscribe(
                      rows => {   
                              this.ultFolio = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnUltimoFolio());

    this.dataService.getVars("PDF_O-D").subscribe(
                      rows => {   
                              this.abrirDescargarPDF = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnPDF_Abrir_Descargar_Obtenido());
    this.dataService.getVars("FOL_DEF").subscribe(
                        rows => {   
                                this.foliosAreasDefault = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnFolios_Areas_Default_Obtenido());
    this.dataService.getVars("ENV_LOG").subscribe(
                          rows => {   
                                  this.enviandoCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnEnvio_Correo_Log_Obtenido());
    this.dataService.getUsrsAdmons("1").subscribe(
                          rows => {   
                                  this.admons = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnAdministradoresCargados());      
    this.dataService.getVars("SAE-CTE").subscribe(
                        rows => {   
                                this.cteSAE = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnCteSAEObtenido());     
    this.dataService.getVarsUnidad("SAE-SER").subscribe(
                        rows => {   
                                this.auxSerSAE = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnSerSAEObtenido());                                                                                             
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnCambiaFecha(tipo, obj){
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
    }
  }

  fnAdministradoresCargados(){
    //console.log(this.admons)
  }

  fnPDF_Abrir_Descargar_Obtenido(){
    //console.log(this.abrirDescargarPDF);
    this.hoy=this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    this.fnSetMsgImpresion();
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
    this.dataService.getVars("FOLIO").subscribe(
                      rows => {   
                              this.sigFolio = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFolioIniObtenido());
  }

  fnFolios_Areas_Default_Obtenido(){
    //console.log(this.foliosAreasDefault);
    this.fnSetMsgFolios();
  }

  fnEnvio_Correo_Log_Obtenido(){
    //console.log(this.enviandoCorreo);
    if(this.enviandoCorreo == 1){
      //this.correoLog = this.enviandoCorreo[0].;
      this.dataService.getEnvioLog().subscribe(
                          rows => {   
                                  this.admonCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnAdmonLogObtenido());
    }
    else{
      this.correoLog = "";
      this.idAdmon = -1;
    }
  }

  fnAdmonLogObtenido(){
    //console.log(this.admonCorreo);
    if(this.admonCorreo.length > 0){
      this.correoLog = this.admonCorreo[0].mail;
      this.idAdmon = this.admonCorreo[0].idPersona;
    }
  }

  fnSetMsgImpresion(){
    if(this.abrirDescargarPDF==0){
      this.impresionTickets = "Imprimir sin previsualizar";
      this.contraImpresionTickets= "Previsualizar antes de imprimir";
    }
    else{
      this.impresionTickets = "Previsualizar antes de imprimir";
      this.contraImpresionTickets = "Imprimir sin previsualizar";
    }

  }

  fnSetMsgFolios(){
    if(this.foliosAreasDefault==1){
      this.reciboAreas = "Imprimir Tickets por default";
      this.contraReciboAreas= "No imprimir Tickets por default";
    }
    else{
      this.reciboAreas = "No imprimir Tickets por default";
      this.contraReciboAreas = "Imprimir Tickets por default";
    }
  }

  fnUltimoFolio(){
    //console.log(this.ultFolio);
  }

  fnFolioIniObtenido(){
    setTimeout(() => {
      //console.log(this.sigFolio)
      if(this.ultFolio < 0){
        delay(200);
      }
      if(this.ultFolio > this.sigFolio)
      this.sigFolio = this.ultFolio + 1;

    }, 35);
  }

  fnFechaEspecialObtenida(){
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
  }

  fnCteSAEObtenido(){
    //console.log(this.cteSAE);
  }

  fnSerSAEObtenido(){
    //console.log(this.auxSerSAE);
    if(this.auxSerSAE)
      this.serSAE = this.auxSerSAE[0].valor;
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("DD/MM/YYYY");
  }

  fnCambiaImpresion(){
    this.dataService.insLog(29,'CONFIG', "PDF_O-D:" + this.abrirDescargarPDF,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("PDF_O-D", this.abrirDescargarPDF ? '0' : '1').subscribe(
                    rows => {   
                            this.abrirDescargarPDF = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnImpresionCambiada(!this.abrirDescargarPDF));
  }

  fnImpresionCambiada(previsualiza:any){
    //console.log(this.abrirDescargarPDF);
    this.fnSetMsgImpresion();
  }

  fnCambiaFoliosDefault(){
    this.dataService.insLog(29,'CONFIG', "FOL_DEF:" + this.foliosAreasDefault,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("FOL_DEF", this.foliosAreasDefault ? '0' : '1').subscribe(
                    rows => {   
                            this.foliosAreasDefault = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnFoliosDefaultCambiado(!this.foliosAreasDefault));
  }

  fnFoliosDefaultCambiado(previsualiza:any){
    //console.log(this.foliosAreasDefault);
    this.fnSetMsgFolios();
  }

  fnCambiaFolio(){
    if(this.thisForm.controls["folio"].value <= this.sigFolio){
      //console.log("El folio debe ser mayor al último folio actual");
      alert("El nuevo Folio inicial debe ser mayor que el siguiente Folio actual");
      return;
    }
    this.dataService.insLog(29,'CONFIG', "FOLIO:" + this.thisForm.controls["folio"].value,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("FOLIO", this.thisForm.controls["folio"].value).subscribe(
                    rows => {   
                            this.sigFolio = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnFolioCambiado());
  }

  fnFolioCambiado(){ 
    //console.log(this.sigFolio);
    if(this.sigFolio>0){
      this.editaFolio=false;
      if(this.admonCorreo.length > 0){    
        var msg = "Folio: '" + this.thisForm.controls["folio"].value + "'∙";
        this.dataService.sendMailLog("Salto de Folio", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
    }
  }

  fnEmailEnviado(){
    console.log("Correo enviado")
  }

  fnCambiaHoy(){
    this.dataService.insLog(29,'CONFIG', "FEC-TIC:" + "HOY()",'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("FEC-TIC", '0').subscribe(
                    rows => {   
                            this.esFechaEspecial = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnFechaActual());
    this.editaFecha = false;
  }

  fnCambiaAntes(){
    //console.log(this.thisForm.controls["fecEsp"].value);
    this.dataService.setVar("FEC-TIC", '1').subscribe(
                    rows => {   
                            this.esFechaEspecial = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnFechaAnterior());
  }

  fnFechaActual(){
    this.dataService.bajaFechaEspecial().subscribe(
                  rows => {   
                          this.resultado = <any>rows
                          },          
                  error => this.errMsg = <any>error,
                  () => this.fnFechaActualizada());
  }

  fnFechaAnterior(){
    this.editaFecha=false;
    this.esFechaEspecial=true;
    this.fechaEspecial = this.thisForm.controls["fecEsp"].value.format("DD/MM/YYYY");  
    this.dataService.insLog(29,'CONFIG', "FEC-TIC:" + this.fechaEspecial,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.altaFechaEspecial(this.thisForm.controls["fecEsp"].value.format("YYYY/MM/DD")).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaActualizada());
  }

  fnFechaActualizada(){
    //console.log(this.resultado);
    if(this.sigFolio>0){
      this.editaFolio=false;
      if(this.admonCorreo.length > 0){    
        var msg = "Fecha: '" + this.thisForm.controls["fecEsp"].value.format("DD/MM/YYYY") + "'∙";
        this.dataService.sendMailLog("Cambio de fecha", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
    }
  }

  fnCambiaCteSAE(){
    //console.log("fnCambiaCteSAE()");
    if(this.thisForm.controls["cteSAE"].value < 1){
      alert("El ID del cliente del sistema ASPEL SAE debe ser mayor que cero");
      return;
    }
    this.dataService.insLog(29,'CONFIG', "SAE-CTE:" + this.thisForm.controls["cteSAE"].value,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("SAE-CTE", this.thisForm.controls["cteSAE"].value).subscribe(
                    rows => {   
                            this.cteSAE = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnCteSAECambiado());
  }

  fnCteSAECambiado(){
    console.log(this.cteSAE);
    if(this.cteSAE>0){
      this.editaCteSAE=false;
      if(this.admonCorreo.length > 0){    
        var msg = "ID Cliente SAE: '" + this.thisForm.controls["cteSAE"].value + "'∙";
        this.dataService.sendMailLog("Cambio de Cliente SAE", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
    }
  }

  fnCambiaSerSAE(){
    console.log("fnCambiaSerSAE()");
    if(this.thisForm.controls["serSAE"].value.length < 2){
      alert("La CLAVE del producto/servicio del sistema ASPEL SAE debe tener al menos 2 caracteres");
      return;
    }
    this.dataService.insLog(29,'CONFIG', "SAE-SER:" + this.thisForm.controls["serSAE"].value,'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVarUnidad("SAE-SER", this.thisForm.controls["serSAE"].value).subscribe(
                    rows => {   
                            this.auxSerSAE = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnSerSAECambiado());
  }

  fnSerSAECambiado(){
    console.log(this.auxSerSAE);
    if(this.auxSerSAE.length > 0){
      this.serSAE = this.thisForm.controls["serSAE"].value;
      this.editaSerSAE=false;
      if(this.admonCorreo.length > 0){    
        var msg = "Clave Servicio SAE: '" + this.thisForm.controls["serSAE"].value + "'∙";
        this.dataService.sendMailLog("Cambio de Servicio/Prod. SAE", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
    }
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="ADMON"){
      this.idAdmon = idEl;
    }
  }

  fnCambiaSinEnvioLog(){
    this.dataService.insLog(29,'CONFIG', "ENV_LOG:" + "SIN ENVIO DE LOG",'').subscribe(
                      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.setVar("ENV_LOG", '0').subscribe(
                    rows => {   
                            this.enviandoCorreo = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnSetMsgEnvioLog("BAJA", "", ""));
    this.editaCorreo = false;

  }

  fnSetMsgEnvioLog(op:string, correo:string, usuario:string){
    console.log(correo);
    if(this.admonCorreo.length > 0){    
      var msg = "";
      var ev = "";
      if(op == "BAJA"){ 
        ev = "Sin envío (BAJA)";
        msg = "Operación: '" + ev + "'∙";
        msg += "Usuario: '" + this.admonCorreo[0].idUsuario + "'∙";       
        msg += "Correo: '" + this.admonCorreo[0].mail + "'∙";       
      }
      if(op == "ALTA"){ 
        ev = "Enviar logs (ALTA)";
        msg = "Operción: '" + ev + "'∙";
        msg += "Usuario: '" + usuario + "'∙";
        msg += "Correo: '" + correo + "'∙";
      }
      this.dataService.sendMailLog(ev, msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                            rows => {   
                                    this.envioMail = rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnEmailEnviado());     
    }
    if(op == "BAJA"){
      this.correoLog = "";
      this.dataService.bajaEnvioLog().subscribe(
                                  rows => {   
                                          this.resultado = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnCorreoActualizado());  
    }
    if(op == "ALTA"){
      this.correoLog = correo;
      this.dataService.altaEnvioLog(this.thisForm.controls["cboAdmon"].value).subscribe(
                    rows => {   
                            this.resultado = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnCorreoActualizado());
    }
  }

  fnCorreoActualizado(){
    //console.log(this.resultado);
    this.editaCorreo = false;
    //this.fnAdmonLogObtenido();
    this.dataService.getUsrsAdmons("1").subscribe(
                      rows => {   
                              this.admons = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnAdministradoresCargados());   
  }

  fnCambiaCorreo(){
    //console.group("Vaidar seleccion: " + this.idAdmon);
    if(this.idAdmon > -1){
      var auxMail = this.dataService.findItemInObject(this.admons, this.idAdmon, "idPersona").mail;
      var auxUser = this.dataService.findItemInObject(this.admons, this.idAdmon, "idPersona").idUsuario;
      this.dataService.insLog(29,'CONFIG', "ENV_LOG:" + auxMail,'').subscribe(
                          row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );  
      this.dataService.setVar("ENV_LOG", '1').subscribe(
                          rows => {   
                                  this.enviandoCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnSetMsgEnvioLog("ALTA", auxMail, auxUser));                                  
    }
    else{
      this.errLogMsg = "Seleccione un correo";  
      setTimeout(() => {
        this.errLogMsg = "";
      }, this.tiempoMsg);
      //console.log(this.errLogMsg);   
    }
  }

}
